import { ClientType } from "../../../types/clientType";
import { Text } from "../../Type";

const ClientCell = ({
  client,
}: {
  client: ClientType;
}) => {
  return (
  <>
    <Text weight="bold" size="medium">
      {client.id ? `${client.first_name} ${client.last_name}` : `${client.first_name}`}
    </Text>
    <Text size="small" fade>
      {client.health_card}
    </Text>
  </>
  );
};

export default ClientCell;
